
// * Меню главное
$('.menu-item-js').hover(
    function () {
        $(this).find('.menu__link').addClass('hovered');
        $(this).find('.drop-menu-js').addClass('active');
        $(this).find('.drop-menu__arrow').addClass('active');
    },
    function () {
        $(this).find('.menu__link').removeClass('hovered');
        $(this).find('.drop-menu-js').removeClass('active');
        $(this).find('.drop-menu__arrow').removeClass('active');
    },
);

if (window.innerWidth <= 991 ){
    $('.menu-item-js').unbind('mouseenter mouseleave mouseout');
}

// * Форма обратной связи
$('.form-action__form').submit(function (e) {
    e.preventDefault();
    let error = 0;
    $(this).find('input').each(function () {
        if ($(this).val() == '')
            error += 1;
    });

    if (error == 0) {
        grecaptcha.ready( () => {
            grecaptcha.execute(document.querySelector('meta[name="google-recaptcha"]').content, {
                action: 'ask_question'
            }).then( (token) =>{
                const inputToken = document.createElement('input')
                inputToken.type = "hidden"
                inputToken.name = "g-recaptcha-response"
                inputToken.value = token
                document.querySelector(".form-action__form").appendChild(inputToken)

                const dataForm = $(this).serialize();

                $.post("/ajax/callback_form.php", dataForm ,(data, textStatus, jqXHR) => {
                    let counter = $('.success-callback-modal-js span');
                    let time = 5;

                    if (data.send == true) {
                        counter.text(time);
                        $('.success-callback-modal-js').css('display', 'block');
                        $('.form-action__form input').val('');
                        $('.form-action__form textarea').val('');

                        let timer = setInterval(() => {
                            counter.text(time);
                            time -= 1;
                        }, 1000);

                        setTimeout(() => {
                            inputToken.remove()
                            clearInterval(timer);
                            $('.success-callback-modal-js').attr('style', '');
                        }, 3500);
                    }
                    else {
                        $('.form-action__form input').val('');
                        $('.form-action__form textarea').val('');
                        inputToken.remove()
                    }
                }, "json");
            })
        });
    }
});

// * Заказ на почту (order)
$('.order-success__mail-form').submit(function (e) {
    e.preventDefault();
    $.post("/ajax/order_form.php", $(this).serialize(), function (data, textStatus, jqXHR) {
        if (data.send == 'true') {
            $('.order-success__mail-input').val('');
        }

    }, "json");

});

// * На главной банер (2)
// * Маленький банер слева
$('body').on('click', '.v1-link-discount', function (e) {
    e.preventDefault();
    let href = $(this).attr('href');
    let sale = $(this).attr('data-sale');

    document.cookie = encodeURIComponent('SALE_PAGE') + '=' + encodeURIComponent(sale) + '; path=/';
    window.location.href = href;
});


// * Клик по большому слайдеру
$('body').on('click', '.main-poster__items', function (e) {
    e.preventDefault();
    let href = $(this).attr('href');
    let sale = $(this).attr('data-sale');

    document.cookie = encodeURIComponent('SALE_PAGE') + '=' + encodeURIComponent(sale) + '; path=/';
    window.location.href = href;
});

// * Цвета в карточки madal
$('body').on('click', '.good-element__color-link', function (e) {
    e.preventDefault();
    $('.modal-color-js').css('display', 'block');
});
$('body').on('click', '.modal-color__close', function (e) {
    e.preventDefault();
    $(this).closest('.modal').attr('style', '');
});

$('body').on('click', '.modal-color__tabs-item', function (e) {
    e.preventDefault();
    let id = $(this).attr('data-tabs');

    $('.modal-color__tabs-item').removeClass('open')
    $('.modal-color__tabs-body').removeClass('open')
    $(this).closest('.modal-color__tabs-item').addClass('open');
    $('.modal-color__tabs-body[data-tabs="' + id + '"]').addClass('open');

    $('.modal-color__tabs-body[data-tabs="' + id + '"]').find('.modal-color__tabs-color').removeClass('active');
    $('.modal-color__tabs-body[data-tabs="' + id + '"]').find('.modal-color__tabs-color').first().addClass('active');


});

$('body').on('click', '.modal-color__tabs-color', function (e) {
    e.preventDefault();
    $(this).closest('.modal-color__tabs-row').find('.modal-color__tabs-color').removeClass('active');
    $(this).addClass('active');
});

$('body').on('click', '.modal-color__btn', function (e) {
    e.preventDefault();
    let item = $(this).closest('.modal-color').find('.modal-color__tabs-body.open').find('.modal-color__tabs-color.active')
    $('.good-element__color-link').text('');

    $('.good-element__color-link').text(item.find('span').text());
    $('.good-element__color-circle img').attr('src', item.find('img').attr('src'));
    $('.good-element__color-text').text('выбрано ')
    $(this).closest('.modal').attr('style', '')
});

// ! Запретить нажимать Enter oredr/contacts.php
$('#bx-soa-order-form').keydown(function(e){
    if(e.keyCode == 13) {
        e.preventDefault();
        return false;
    }
});


// * Меняет ссылки в карточки товара
if ($('a[data-href]').length > 0) {
    $('a[data-href]').each(function () {
        $(this).attr('href', $(this).attr('data-href'));
        $(this).removeAttr('data-href');
    });
}


// * Очистка избранного
$('.favorite-page__delete').click(function () {
    document.cookie = encodeURIComponent('k1FavoriteGoods') + '=' + encodeURIComponent('') + '; path=/';
    window.location.reload();
});

// * Добавление в корзину из Избранного
$('.favorite-page__btn').click(function () {
    let items = $('.good-item');
    let arID = {};
    items.each(function (index, element) {
        arID[index] = {
            'ID': $(this).find('.good-item__compare-modal').attr('data-product-id'),
            'PROPS_VAL': $(this).find('.product-item-scu-item-text-container.selected').attr('data-val')
        };
    });

    $.ajax({
        type: "POST",
        url: "/ajax/add_favorite-basket.php",
        data: 'idJson=' + JSON.stringify(arID),
        dataType: "json",
        complete: function () {
            window.location.reload()
        },
    });
});


// * Кстомный select
if ($('body').find('.v1-select').length > 0) {
    $('.v1-select').css('max-width', $('.v1-select').attr('data-width') + 'px')
    $('.v1-select__box').each(function () {
        $(this).css('max-height', 'unset');
        let height = $(this).outerHeight();
        $(this).attr('data-height', height);
        $(this).removeAttr('style');
    });
}
$('.v1-select__value').click(function (e) {
    e.preventDefault();
    let _this = $(this).closest('.v1-select');

    if (_this.hasClass('open')) {
        _this.removeClass('open');
        _this.find('.v1-select__box').attr('style', '')
    } else {
        _this.addClass('open');
        _this.find('.v1-select__box').css('max-height', _this.find('.v1-select__box').attr('data-height') + 'px')
        if (window.innerWidth < 767) window.NoScroll.show(true)

    }
});
$('.v1-select__option').click(function (e) {
    e.preventDefault();
    let _this = $(this).closest('.v1-select');
    let value = $(this).attr('data-value');
    let text = $(this).text();

    _this.find('.v1-select__option').removeClass('selected')
    $(this).addClass('selected')

    _this.find('.v1-select__value span').text(text)
    _this.find('input[type="hidden"]').val(value)

    _this.find('.v1-select__box').attr('style', '')
    _this.removeClass('open')
    if (window.innerWidth < 767) window.NoScroll.hide()

});
$('.v1-select__box').mouseleave(function () {
    $(this).attr('style', '')
    $(this).closest('.v1-select').removeClass('open')
});

if (window.innerWidth < 767) {
    $('.v1-select__list').click(function (e) {
       e.stopPropagation();
    });
    $('.v1-select__box').click(function (e) {
        if ($(this).closest('.v1-select').hasClass('open')){
            $(this).attr('style', '')
            $(this).closest('.v1-select').removeClass('open')
            window.NoScroll.hide()
        }
    });

}


// * Stati form ajax modal
$('.v1-stati__form').submit(function (e) {
    e.preventDefault();
    $.ajax({
        type: "POST",
        url: "./../../ajax/stati_ajax.php",
        data: $(this).serialize(),
        dataType: "text html",
        success: function (response) {
            // console.log(response)
            let height = $('.v1-stati__modal-body').outerHeight() + 20;
            $('.v1-stati__modal-link').attr('href', response);
            $('.v1-stati__modal').addClass('open');
            $('.v1-stati__modal-bg').css('min-height', height + 'px');
            $('.v1-stati__form').find('input[type="text"]').val('').removeClass('valid');
            $('.v1-stati__form').find('textarea').val('').removeClass('valid');
        }
    });
});
$('.v1-stati__modal-close').click(function (e) {
    e.preventDefault();
    $(this).closest('.v1-stati__modal').removeClass('open')
});


// * Mobile header search
$('.header__seach-mobile img').on('click', function () {
    // console.log('Mobile header search');
    $(this).closest('.header__seach-mobile').toggleClass('open');
});
$(document).mouseup( function(e){
    var search = $( ".header__seach-mobile" );
    if ( !search.is(e.target) && search.has(e.target).length === 0 ) {
        search.removeClass('open');
    }
});


// ? Modile
$('body').on('click', '.main-choose__items-mobile', function (e) {
    e.preventDefault();
    $(this).toggleClass('open');
    $(this).find('.main-choose__items-bottom').slideToggle();
});


// * Mobile click detailed card
$('.element-main__description-mobile .element-main__description-top').click(function (e) {
    e.preventDefault();
    $(this).closest('.element-main__description-mobile').toggleClass('opened');
});

$('.element-composition.mobile .element-main__composition-title').click(function (e) {
    e.preventDefault();
    $(this).closest('.element-composition.mobile').toggleClass('opened');
});

$('.element-main__stats.mobile .element-main__stats-title ').click(function (e) {
    e.preventDefault();
    $(this).closest('.element-main__stats.mobile').toggleClass('opened');
});

$('.element-aside__block.mobile .element-aside__title').click(function (e) {
    e.preventDefault();
    $(this).closest('.element-aside__block.mobile').toggleClass('opened');
});

$('.element-social.mobile .element-social__title').click(function (e) {
    e.preventDefault();
    $(this).closest('.element-social.mobile').toggleClass('opened');
});

$('.element-reviews.mobile .element-reviews__mobile-title').click(function (e) {
    e.preventDefault();
    $(this).closest('.element-reviews.mobile').toggleClass('opened');
});

$('.element-buttons__fixed-btn').on('click', function () {
    let id = $(this).attr('data-id');
    let btn = $('#'+id);

    if(btn){
        document.getElementById(id).click();
    }
});

$('.element-composition__item').on('click', function () {


    if(window.innerWidth < 991){
        if ( $(this).hasClass('open') ){
            $(this).closest('.element-composition__list').find('.element-composition__item.open').removeClass('open')
        } else {
            $(this).closest('.element-composition__list').find('.element-composition__item.open').removeClass('open')
            $(this).addClass('open')
        }
    }

});


// * Mobile Filter click
$('body').on('click', '.header-mobile__title', function (e) {
    e.preventDefault();
    $('.header-mobile').removeClass('open');
});

$('body').on('click', '.section-goods__mobile-filter', function (e) {
    e.preventDefault();
    $('.filter-mobile').addClass('open');
    $('#wrapper').addClass('noscroll');

});

$('body').on('click', '.filter-mobile__close', function (e) {
    e.preventDefault();
    $('.filter-mobile').removeClass('open');
    $('#wrapper').removeClass('noscroll');
});

$('body').on('click', '.filter-mobile .filter-mobile__top', function (e) {
    e.preventDefault();
    $(this).closest('.k1-filter__box').toggleClass('open');
});

$('body').on('click', '.order-mobile__delete', function (e) {
    e.preventDefault();
    $(this).closest('.order-cart__item').find('.basket-items-list-item-remove').toggleClass('open');
    $(this).toggleClass('open');
});

$('.way-pay__v1-js').hover(
    function () {
        let mobile = $('.way-pay__mobile');
        mobile.html('');
        mobile.prepend( $(this).find('.way-pay__row-item-hover').html());
        mobile.addClass('open');

        let heightMobile = Math.round(mobile.height() + 25 );
        mobile.css('top', heightMobile + 'px')
        // over
    }, function () {
        let mobile = $('.way-pay__mobile');
        mobile.html('');
        mobile.removeClass('open');
        mobile.attr('style','');
        // out
    }
);

//* modal overt
// $('body').on('click', '.modal-overt .modal__close', function (e) {
//     e.preventDefault();
//     $(this).closest('.modal').hide();
// });

$('.modal-overt ').on('click', function (e) {
    const target = e.target
    if (target.closest('.modal__close') || !target.closest(".modal__body")) {
        $(this).hide();
        $('body').attr('style', '');
    }
});

$('body').on('click', '.js-modal-overt', function (e) {
    e.preventDefault();
    $('.modal-overt').show();
    $('body').css("overflow","hidden");
});


/// Модалка на странице контакты
